var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavourite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "favourite_svg__circle",
    stroke: "currentColor",
    d: "M24 3c5.78977 0 11.03952 2.35553 14.842 6.158C42.64446 12.96049 45 18.21024 45 24c0 5.78977-2.35553 11.03952-6.158 14.842C35.03951 42.64446 29.78976 45 24 45c-5.78977 0-11.03952-2.35553-14.842-6.158C5.35554 35.03951 3 29.78976 3 24c0-5.78977 2.35553-11.03952 6.158-14.842C12.96049 5.35554 18.21024 3 24 3z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "favourite_svg__heart",
    stroke: "currentColor",
    d: "M24 34c19.00693-12.29585 6.19791-22.6085 0-15.86561C17.80209 11.3915 4.99307 21.70415 24 34z",
    strokeWidth: 2
  }))));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/favourite.svg";
export { SvgFavourite as ReactComponent };